import { runGovernorCallAgent } from './GovernorCallAgent';
import { runGovernorTreeAgent } from './GovernorTreeAgent';
import { runGovernorRelationshipAgent } from './GovernorRelationshipAgent';
import { runGovernorMessagingAgent } from './GovernorMessagingAgent';
import { runGovernorAuthAgent } from './GovernorAuthAgent';
import { runGovernorMembershipAgent } from './GovernorMembershipAgent';
import { runGovernorDatabaseAgent } from './GovernorDatabaseAgent';
import { runGovernorAndroidAgent } from './GovernorAndroidAgent';
import { runGovernorMediaAgent } from './GovernorMediaAgent';
import { runGovernorCoreAgent } from './GovernorCoreAgent';

export type GovernorSubsystemStatus = 'registered' | 'active' | 'unknown' | 'disabled';

export interface GovernorSubsystem {
  id: string;
  name: string;
  phase: string;
  purpose: string;
  status: GovernorSubsystemStatus;
  priority: 'critical' | 'high' | 'medium' | 'low';
}

export const KINSCIRCLE_GOVERNOR_REGISTRY: GovernorSubsystem[] = [
  { id: 'tree', name: 'Tree Integrity', run: runGovernorTreeAgent, phase: 'family-graph', purpose: 'Protect parent, child, side, spouse, co-parent, duplicate, and orphan rules.', status: 'active', priority: 'critical' },
  { id: 'relationships', name: 'Relationship Integrity', run: runGovernorRelationshipAgent, phase: 'family-graph', purpose: 'Validate spouse, co-parent, in-law, child, sibling, and branch placement behavior.', status: 'active', priority: 'critical' },
  { id: 'calls', name: 'Native Calls', run: runGovernorCallAgent, phase: 'communications', purpose: 'Verify incoming call delivery, Android notifications, Firebase, room data, missed calls, and accept/decline flow.', status: 'active', priority: 'critical' },
  { id: 'messaging', name: 'Messaging', run: runGovernorMessagingAgent, phase: 'communications', purpose: 'Verify direct messages, unread counts, call messages, and notification routing.', status: 'active', priority: 'high' },
  { id: 'auth', name: 'Auth & Recovery', run: runGovernorAuthAgent, phase: 'identity', purpose: 'Verify login, signup, password reset, confirmation, routing, and session handling.', status: 'active', priority: 'critical' },
  { id: 'membership', name: 'Membership & Pricing', run: runGovernorMembershipAgent, phase: 'commerce', purpose: 'Verify pricing, trial, founder plan, subscription visibility, and footer/page integrity.', status: 'active', priority: 'high' },
  { id: 'media', name: 'Media & Memories', run: runGovernorMediaAgent, phase: 'content', purpose: 'Verify photos, videos, uploads, galleries, dating, and preservation behavior.', status: 'active', priority: 'medium' },
  { id: 'android', name: 'Android Runtime', run: runGovernorAndroidAgent, phase: 'native', purpose: 'Verify APK, Firebase service, manifest permissions, notification channels, and native call readiness.', status: 'active', priority: 'critical' },
  { id: 'database', name: 'Database Integrity', run: runGovernorDatabaseAgent, phase: 'data', purpose: 'Verify Supabase data, RLS, duplicate prevention, orphan checks, RPCs, and edge consistency.', status: 'active', priority: 'critical' },
  { id: 'governor', name: 'Governor Core', run: runGovernorCoreAgent, phase: 'system', purpose: 'Coordinate discovery, root cause, execution, self-healing, memory, deploy gate, and runtime reporting.', status: 'active', priority: 'critical' },
];

export function getGovernorRegistry() {
  return KINSCIRCLE_GOVERNOR_REGISTRY;
}

export function getGovernorSubsystem(id: string) {
  return KINSCIRCLE_GOVERNOR_REGISTRY.find(s => s.id === id) || null;
}


export const governorRegistry = KINSCIRCLE_GOVERNOR_REGISTRY;
